module.exports = __webpack_public_path__ + "img/twitter.b0e9f041.svg";